import $ from 'jquery';
import ServerError from './ServerError';
import ContentType from './ContentType';

class Request {

    constructor() {
        this._ajax = function (args) {
            function done(data) {
                return Promise.resolve(data);
            }

            function fail(xhr) {
                try {
                    throw new ServerError(xhr);
                } catch (e) {
                    return Promise.reject(e);
                }
            }

            return Promise.resolve($.ajax(args)).then(done, fail);
        };
    }

    postAsync(url, content, contentType, auth) {
        let args = {
            type: 'POST',
            url: url,
            dataType: 'json',
            contentType: contentType
        };

        if (content) {
            if (contentType === ContentType.FORM)
                args = Object.assign({}, args, {data: content});
            else
                args = Object.assign({}, args, {data: JSON.stringify(content)});
        }

        if (auth)
            args = Object.assign({}, args, {headers: {Authorization: 'Bearer ' + auth}});

        return this._ajax(args);
    }

    getAsync(url, queryString, contentType, auth) {
        let args = {
            type: 'GET',
            url: url,
            dataType: 'json',
            contentType: contentType
        };

        if (queryString)
            args = Object.assign({}, args, {data: queryString});

        if (auth)
            args = Object.assign({}, args, {headers: {Authorization: 'Bearer ' + auth}});

        return this._ajax(args);
    }

    deleteAsync(url, queryString, contentType, auth) {
        let args = {
            type: 'DELETE',
            url: url,
            dataType: 'json',
            contentType: contentType
        };

        if (queryString)
            args = Object.assign({}, args, {data: queryString});

        if (auth)
            args = Object.assign({}, args, {headers: {Authorization: 'Bearer ' + auth}});

        return this._ajax(args);
    }
}

export default new Request();



// WEBPACK FOOTER //
// src/web/Ajax.js